// Das Symbol von clubhub: ein Wappenschild-Quadrat im Hausrot mit
// einem offenen „c“ und einem Punkt (der Ball, der Treffpunkt).
// Dieselbe Form erzeugt `app/icons/[groesse]` fuer die App-Symbole.
import { cn } from "@/lib/utils";

export function ClubhubMark({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 32 32" aria-hidden className={cn("h-6 w-6 shrink-0", className)}>
      <rect width="32" height="32" rx="8" className="fill-accent" />
      <path
        d="M20.6 11.2a7 7 0 1 0 0 9.6"
        fill="none"
        stroke="white"
        strokeWidth="3.2"
        strokeLinecap="round"
      />
      <circle cx="22.4" cy="16" r="2.2" fill="white" />
    </svg>
  );
}
